module.exports = __webpack_public_path__ + "assets/e49e99a765aa54e147af82f32f0313ce.ttf";